module.exports = __webpack_public_path__ + "img/scene10.8c52ce5d.gif";